module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_04B.0f4c4a55.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_04B.mp3
// module id = 106
// module chunks = 0